// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().primaryKey().name("encounter_id"),
  worldId: __t.u64().name("world_id"),
  allowed: __t.bool(),
  paused: __t.bool(),
  pausedBy: __t.option(__t.identity()).name("paused_by"),
  pausedAt: __t.option(__t.timestamp()).name("paused_at"),
  remainingMs: __t.u32().name("remaining_ms"),
  pauseBudgetMs: __t.option(__t.u32()).name("pause_budget_ms"),
});
